import vars from '@/config/vars';
import axios from '@/config/axios.config';
import mocked from '@/mockedPreorder';
import ShippingTypes from '@/models/ShippingTypes';
import { logEvent } from '@/helpers/cieloLogger';

export default {
    namespaced: true,

    state: {
        Methods: [],
        ShippingMethodId: null,
        ShippingType: null,
        ShippingChecksum: null,
        ShippingDeadline: null,
        ShowShippingMethod: false
    },

    getters: {
        /**
         * Monta o contrato de autorização
         */
        getSubmitModel(state) {
            return {
                ShippingMethodId: state.ShippingMethodId,
                ShippingType: state.ShippingType,
                ShippingMethods: state.Methods,
                ShippingChecksum: state.ShippingChecksum,
                ShippingDeadline: state.ShippingDeadline
            };
        },

        getMethods(state) {
            return state.Methods;
        },

        getMethod(state) {
            if(state.Methods)
                return state.Methods.filter(item => item.id == state.ShippingMethodId)[0];

            return false;
        },

        getType(state) {
            return state.ShippingType;
        },

        getShowShippingMethod(state) {
            return state.ShowShippingMethod;
        }
    },

    mutations: {
        setShippingMethodId: (state, id) => state.ShippingMethodId = id,
        setShippingType: (state, type) => state.ShippingType = type,
        setShippingDeadline: (state, deadline) => state.ShippingDeadline = deadline,
        setShowShippingMethod: (state, show) => state.ShowShippingMethod = show,

        /**
         * Mapeia o response da preorder para o módulo
         */
        setFromRequest(state, data) {
            if (!data) return;

            // Mapeamento para as apis, que retornam maiúsculas em alguns endpoints e maiúsculas em outros.
            state.Methods = data.map(method =>
            {
                let item  = {
                    carrierId: method.CarrierId || method.carrierId || 0,
                    description: method.Description || method.description || '',
                    formattedPrice: method.FormattedPrice || method.formattedPrice,
                    id: method.Id || method.id,
                    price: method.Price || method.price || 0,
                    deadLine: method.DeadLine || method.deadLine || 0,
                    img: '',
                    shippingTypeLoggi: false,
                    observation: method.observation
                };

                const isLoggi =  new RegExp(/\bloggi\b/,'gi').test(item.description);

                /**
                 * Assume-se que caso o shipping type seja loggi e não retorne loggi no cálculo,
                 * o fallback dos correios foi acionado, portanto precisamos alterar o shipping type
                 * para enviar oa backend.
                 */
                if (state.ShippingType == ShippingTypes.LOGGI && isLoggi == false)
                {
                    state.ShippingType = ShippingTypes.CORREIOS;
                }

                item.shippingTypeLoggi = isLoggi;
                item.img = isLoggi
                    ? require('@/assets/img/shipping-type-card-loggi.svg')
                    : require('@/assets/img/icons/freight.svg');

                return item;
            });
        },

        /**
         * Mapeia o checksum retornado da api para o módulo
         */
        setChecksumFromShippingApiRequest(state, data) {
            state.ShippingChecksum = data.checksum;
        },
    },

    actions: {
        setShippingMethodId({ commit }, payload) {
            commit('shippingType/setShippingMethodId', payload.id, { root: true });
            commit('shippingType/setShippingDeadline', payload.deadLine, { root: true });
            commit('payment/setShippingPrice', payload.price, { root: true });
        },

        async calculateShipping({ commit, rootGetters, rootState }) {
            /**
             * SIMULADO
             */
            if (vars.USE_SIMULATED_MODE) {
                await new Promise(resolve => {
                    setTimeout(() => {
                        const data = mocked.ShippingMethodsCorreios;

                        commit('shippingType/setFromRequest', data, { root: true });
                        resolve();
                    }, 2000);
                });
                return;
            }

            /**
             * PRODUÇÃO
             */
            let preorderId = rootState.preorder.Id;
            let sourceZipCode = rootGetters['shoppingCart/getSourceZipCode'];
            let targetZipCode = rootGetters['shippingAddress/getTargetZipCode'];
            let weight = rootGetters['shoppingCart/getTotalWeight'] || 0;
            let {
                Street,
                Number,
                City,
                District,
                State,
                Complement
            } = rootState['shippingAddress'];

            let response = await axios.post('ShippingPrice', {
                preorderId,
                sourceZipCode,
                targetZipCode,
                weight,
                Street,
                Number,
                City,
                District,
                State,
                Complement
            });

            if(!response.data.types || response.data.types.length == 0)
                throw new Error();

            commit('setFromRequest', response.data.types);
            commit('setChecksumFromShippingApiRequest', response.data);
        }
    }
};
